import { useState } from "react"
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { AuthoringAuthorNotesEntry } from "./authoring-author-notes-entry"
import { DraftRejectionComment } from "./draft-rejection-comment"
import { DraftReturnedToEditingComment } from "./draft-returned-to-editing-comment"

export function AuthoringAuthorNotesCycle({ item: cycle }) {
    const [expanded, setExpanded] = useState(() => cycle?.isCurrent ?? false)

    return (
        <Accordion
            data-cy="authoring-author-notes-cycle"
            expanded={expanded}
            onChange={(_, isExpanded) => setExpanded(isExpanded)}
            sx={{
                my: "1px !important",
                boxShadow: "inset 0px -1px 0px rgba(145, 158, 171, 0.24)",
                "&:before": { display: "none" },
            }}
        >
            <AccordionSummary
                expandIcon={<Iconify icon="ic:round-chevron-right" width="24px" height="24px" rotate="90deg" />}
            >
                <Typography variant="subtitle1">Review Cycle {cycle?.reviewCycle}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <DraftReturnedToEditingComment returnedToEditing={cycle?.returnedToEditing} />
                <DraftRejectionComment
                    rejection={cycle?.rejection}
                    approvedCount={cycle?.decisionCounts?.approved ?? 0}
                    rejectedCount={cycle?.decisionCounts?.rejected ?? 0}
                />
                <If
                    truthy={(cycle?.entries ?? []).length > 0}
                    then={<Repeat list={cycle?.entries ?? []} item={<AuthoringAuthorNotesEntry />} />}
                    else={
                        <Typography variant="body2" color="text.secondary">
                            No author notes for this cycle.
                        </Typography>
                    }
                />
            </AccordionDetails>
        </Accordion>
    )
}
